<template>
<div class="page over">
    <Header title="传承师信息" />
    <div class="form-wrap">
        <div class="line">
            <p>传承师头像</p>
            <div class="avatar">
                <UploadAvatar class="upload" @callback="uploadCallback" />
                <img :src="infoData.inheritor_cover || Images.img_avatar_default">
            </div>
        </div>
        <div class="line">
            <p>传承师姓名</p>
            <van-field v-model="infoData.inheritor_name" placeholder="请输入姓名" input-align="right" :border="false" />
        </div>
        <div class="line">
            <p>手机号</p>
            <van-field type="number" v-model="infoData.inheritor_mobile" placeholder="请输入手机号" input-align="right" :border="false" />
        </div>
        <div class="line-textarea">
            <p>传承师简介</p>
            <van-field v-model="infoData.inheritor_introduce" type="textarea" class="text-area-wrap" placeholder="请填写简介" :autosize="true" :border="false" />
        </div>
    </div>
    <div class="btn" @click="onPressSubmit">立即{{isEdit > 0 ? '修改' : '提交'}}</div>
</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import Header from "@/components/Header";
import UploadAvatar from "@/components/UploadAvatar";
export default {
    components: {
        Header: Header,
        UploadAvatar
    },
    computed: {
        ...mapGetters(["userInfo"]),
    },
    data() {
        return {
            uploader: [],
            isEdit: this.$route.query.isEdit || 0,
            infoData: this.$route.query.infoData || {
                inheritor_cover: "",
                inheritor_name: "",
                inheritor_mobile: "",
                inheritor_introduce: "",
            },
        };
    },
    mounted() {
        this._initInfoData();
    },
    methods: {

        _initInfoData() {
            if (this.isEdit > 0) {
                this._requestInheritorInfo()
            } else {
                if (this.userInfo) {
                    this.infoData = {
                        ...this.infoData,
                        inheritor_cover: this.userInfo.avatar,
                        inheritor_mobile: this.userInfo.mobile,
                        inheritor_name: this.userInfo.real_name,
                    }
                }
            }
        },

        async _requestInheritorInfo() {
            let url = this.API.master_agent_info;
            let params = {
                user_type: 'master',
                token: this.Lockr.get('token')
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.infoData = result.data;
            }
        },

        // 图片选择回调
        uploadCallback(res) {
            console.log('res---->', res);
            this.infoData.inheritor_cover = res
        },

        // 提交请求
        async onPressSubmit() {
            let url = this.API.master_apply;
            let params = {
                token: this.Lockr.get("token"),
                ...this.infoData,
            };
            let result = await this.$post(url, params);
            let that = this;
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                this.$store.dispatch("UserInfo", true)
                this.Message({
                    title: result.msg,
                    onClose: () => {
                        this.$router.go(-1);

                    }
                });
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
    },
};
</script>

<style lang="less" scoped>
.page {
    box-sizing: border-box;

    .form-wrap {
        padding: 0 1rem;
        overflow: hidden;
        background: #fff;
        margin: 1rem 1rem;
        border-radius: .5rem;

        .line {
            padding: 0 10px;
            height: 50px;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px dashed #ddd;

            &:last-of-type {
                border: 0;
            }

            p {
                height: 50px;
                margin-right: 10px;
                font-size: 15px;
                color: #333;
                line-height: 50px;
            }

            .avatar {
                width: 40px;
                height: 40px;
                position: relative;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    object-fit: cover;
                }

                .upload {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                }
            }

            span {
                font-size: 15px;
                color: #333;
            }

            .van-field {
                flex: 1;
                padding: 0;
                text-align: right;
            }
        }

        .line-textarea {
            padding: 0 10px 10px;
            background: #fff;
            display: flex;
            flex-direction: column;

            p {
                height: 50px;
                margin-right: 10px;
                font-size: 15px;
                color: #333;
                line-height: 50px;
            }

            .text-area-wrap {
                padding: 1rem 1rem;
                background: #f7f8f9;
            }

            /deep/ textarea {
                flex: 1;
                box-sizing: border-box;
                border-width: 0px;
                resize: none;
                font-size: 15px;
                color: #333;
                text-align: justify;
            }
        }

    }

    .btn {
        margin: 50px 15px;
        height: 40px;
        background: linear-gradient(225deg, #9cb2f4, #6472e8);
        border-radius: 3px;
        font-size: 15px;
        color: #fff;
        text-align: center;
        line-height: 40px;
    }
}
</style>
